import { LevelType } from 'data/types';
import { getAllAdjacentSpaces, getGridSpacesForLevel } from 'utils/grid';

export function ptacRoomsTouch(
  structure: LevelType[],
  spaceIdA: string,
  spaceIdB: string
): boolean {
  if (spaceIdA === spaceIdB) return true;
  return structure.some((level, index) => {
    const levelSpaces = getGridSpacesForLevel(structure, index);
    const roomA = levelSpaces.find((space) => space.spaceId === spaceIdA);
    const roomB = levelSpaces.find((space) => space.spaceId === spaceIdB);
    if (!roomA || !roomB) return false;
    const adjacent = getAllAdjacentSpaces(roomA, levelSpaces);
    return [
      ...adjacent.top,
      ...adjacent.right,
      ...adjacent.bottom,
      ...adjacent.left
    ].some((space) => space.spaceId === spaceIdB);
  });
}

export function ptacRoomsTouchIn(structure: LevelType[]) {
  return (spaceIdA: string, spaceIdB: string) =>
    ptacRoomsTouch(structure, spaceIdA, spaceIdB);
}
